const PLATFORMS = ['IOS', 'ANDROID'];

export function compareAppVersions(left, right) {
  const parse = (value) => /^\d+\.\d+\.\d+$/.test(String(value || ''))
    ? String(value).split('.').map(Number) : null;
  const a = parse(left);
  const b = parse(right);
  if (!a || !b) return null;
  for (let index = 0; index < 3; index += 1) {
    if (a[index] !== b[index]) return a[index] > b[index] ? 1 : -1;
  }
  return 0;
}

export function releasedVersionsByPlatform(versions = []) {
  return Object.fromEntries(PLATFORMS.map((platform) => {
    const rows = versions.filter((row) => row.platform === platform && row.release_stage === 'RELEASED' && !row.deleted_at);
    rows.sort((a, b) => compareAppVersions(b.version_name, a.version_name)
      || Number(b.build_number || 0) - Number(a.build_number || 0)
      || String(b.released_at || '').localeCompare(String(a.released_at || '')));
    return [platform, rows[0] || null];
  }));
}

export function releasedOnBothPlatforms(version, released) {
  return PLATFORMS.every((platform) => {
    const current = released[platform]?.version_name;
    const order = compareAppVersions(current, version);
    return order !== null && order >= 0;
  });
}

export function releaseCenterDiscrepancies({ plans = [], releases = [], candidates = [], released = {} }) {
  const stalePlans = plans.filter((plan) => !plan.deleted_at && !['RELEASED', 'CANCELLED'].includes(plan.status)
    && releasedOnBothPlatforms(plan.version_name, released));
  const staleReleases = releases.filter((release) => release.status !== 'RELEASED'
    && releasedOnBothPlatforms(release.version_name, released));
  const committedCandidates = candidates.filter((candidate) => candidate.status === 'COMMITTED'
    && releasedOnBothPlatforms(candidate.committed_version, released));
  return { stalePlans, staleReleases, committedCandidates };
}

export function versionLabel(row) {
  return row ? `${row.version_name}${row.build_number ? ` (${row.build_number})` : ''}` : '—';
}
